export interface VideoItem {
  id: string;
  title: string;
  category: string;
  rating: number;
  views: string;
  year: string;
  region: string;
  description: string;
  imageSeq: string;
  imageQuery: string;
}

export const categoryVideos: Record<string, VideoItem[]> = {
  dianying: [
    {
      id: "m1",
      title: "流浪地球3",
      category: "电影",
      rating: 9.2,
      views: "1280万",
      year: "2024",
      region: "中国大陆",
      description: "太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的宇宙旅程，年轻一代挺身而出，展开一场争分夺秒的生死之战。",
      imageSeq: "cat-movie-01",
      imageQuery: "Futuristic sci-fi movie poster with space station and Earth in background, warm golden lighting, cinematic composition, minimalist design, clean dark background with orange accents, high detail, 8K quality",
    },
    {
      id: "m2",
      title: "封神第二部",
      category: "电影",
      rating: 8.9,
      views: "2150万",
      year: "2024",
      region: "中国大陆",
      description: "殷商末年，纣王暴虐无道，姜子牙携封神榜下山，辅佐武王伐纣。仙界、人界、妖界三界大战一触即发，史诗级神话巨制。",
      imageSeq: "cat-movie-02",
      imageQuery: "Chinese epic fantasy film poster, ancient Chinese palace silhouette, mystical clouds and golden light, dramatic composition, warm tone, cinematic atmosphere, 8K quality",
    },
    {
      id: "m3",
      title: "奥本海默",
      category: "电影",
      rating: 9.0,
      views: "1890万",
      year: "2023",
      region: "美国",
      description: "讲述了美国'原子弹之父'罗伯特·奥本海默在二战期间领导曼哈顿计划研制原子弹的故事，以及战后他面临的政治迫害与道德困境。",
      imageSeq: "cat-movie-03",
      imageQuery: "Historical drama film poster, atomic age aesthetic, dramatic explosion silhouette in warm orange and dark contrast, minimalist cinematic design, intense atmosphere, 8K quality",
    },
    {
      id: "m4",
      title: "抓娃娃",
      category: "电影",
      rating: 8.7,
      views: "5670万",
      year: "2024",
      region: "中国大陆",
      description: "一对富豪夫妻为了培养孩子，假装贫困生活了十几年。当真相被揭开，一场关于教育观念、家庭关系的爆笑喜剧就此展开。",
      imageSeq: "cat-movie-04",
      imageQuery: "Chinese comedy film poster, warm family living room scene, soft golden sunlight through window, cozy atmosphere, lighthearted mood, clean composition, 8K quality",
    },
    {
      id: "m5",
      title: "沙丘2",
      category: "电影",
      rating: 8.8,
      views: "3210万",
      year: "2024",
      region: "美国",
      description: "保罗·厄崔迪斯与弗雷曼人联手，踏上向摧毁他家庭的阴谋者复仇的征程。面对一生挚爱与已知宇宙命运之间的抉择，他必须阻止只有他能预见的可怕未来。",
      imageSeq: "cat-movie-05",
      imageQuery: "Epic sci-fi desert planet poster, massive sand dunes under golden sun, mysterious atmosphere, cinematic wide shot, warm amber and sandy tones, dramatic lighting, 8K quality",
    },
    {
      id: "m6",
      title: "热辣滚烫",
      category: "电影",
      rating: 8.5,
      views: "7890万",
      year: "2024",
      region: "中国大陆",
      description: "一个宅女通过拳击找到自我、改变人生的励志故事。从自卑到自信，从迷茫到坚定，她用汗水书写了属于自己的滚烫人生。",
      imageSeq: "cat-movie-06",
      imageQuery: "Chinese inspirational sports film poster, boxing ring with warm spotlight, athletic silhouette, dynamic motion, warm golden lighting, powerful composition, 8K quality",
    },
    {
      id: "m7",
      title: "年会不能停",
      category: "电影",
      rating: 8.6,
      views: "4320万",
      year: "2023",
      region: "中国大陆",
      description: "打工人版《肖申克的救赎》，一个被错调到大公司的普通钳工，在年会筹备过程中引发了一系列啼笑皆非的故事，戳中无数打工人的心。",
      imageSeq: "cat-movie-07",
      imageQuery: "Chinese workplace comedy film poster, modern office party scene, warm indoor lighting, festive atmosphere, humorous mood, clean corporate aesthetic, 8K quality",
    },
    {
      id: "m8",
      title: "芭比",
      category: "电影",
      rating: 8.3,
      views: "2980万",
      year: "2023",
      region: "美国",
      description: "在完美梦幻的芭比乐园里，一位芭比开始产生存在危机，她必须前往现实世界寻找答案。一场关于自我认知与女性力量的奇妙冒险。",
      imageSeq: "cat-movie-08",
      imageQuery: "Pink themed fantasy film poster, dreamy dollhouse aesthetic, warm pastel tones, whimsical atmosphere, creative set design style, soft lighting, 8K quality",
    },
  ],
  dianshiju: [
    {
      id: "t1",
      title: "繁花",
      category: "电视剧",
      rating: 9.5,
      views: "3560万",
      year: "2023",
      region: "中国大陆",
      description: "九十年代的上海，处处是机遇与挑战。阿宝凭借一手炒股绝技和敏锐的商业嗅觉，在黄河路上崭露头角，成为人人皆知的'宝总'。",
      imageSeq: "cat-tv-01",
      imageQuery: "Shanghai 1990s nostalgic drama poster, neon lights at night, urban atmosphere, warm amber tones, cinematic photography style, soft focus background, elegant composition, 8K quality",
    },
    {
      id: "t2",
      title: "狂飙",
      category: "电视剧",
      rating: 9.3,
      views: "6780万",
      year: "2023",
      region: "中国大陆",
      description: "一个底层鱼贩如何一步步成为黑恶势力头目，一名警察如何在二十年间坚持不懈地追查真相。正与邪的较量，人性的沉沦与救赎。",
      imageSeq: "cat-tv-02",
      imageQuery: "Crime thriller drama poster, urban night scene with rain on streets, moody atmospheric lighting, dark warm tones, cinematic film noir style, suspenseful composition, 8K quality",
    },
    {
      id: "t3",
      title: "漫长的季节",
      category: "电视剧",
      rating: 9.4,
      views: "2890万",
      year: "2023",
      region: "中国大陆",
      description: "一座北方小城，跨越二十年的悬疑故事。出租车司机王响在寻找失踪儿子的过程中，牵扯出一段尘封已久的往事。",
      imageSeq: "cat-tv-03",
      imageQuery: "Chinese mystery drama poster, northern small town in autumn, golden leaves and warm nostalgic lighting, melancholic atmosphere, cinematic composition, 8K quality",
    },
    {
      id: "t4",
      title: "三体",
      category: "电视剧",
      rating: 8.8,
      views: "5230万",
      year: "2023",
      region: "中国大陆",
      description: "多位科学家离奇自杀，纳米科学家汪淼被警官史强带到联合作战中心，潜入名为'科学边界'的组织，揭开地外文明'三体'世界的神秘面纱。",
      imageSeq: "cat-tv-04",
      imageQuery: "Sci-fi thriller TV series poster, cosmic background with three suns, mysterious alien signal waves, dark and warm contrast, intellectual atmosphere, 8K quality",
    },
    {
      id: "t5",
      title: "庆余年第二季",
      category: "电视剧",
      rating: 8.6,
      views: "4560万",
      year: "2024",
      region: "中国大陆",
      description: "范闲从北齐归来后，发现京都暗流涌动。各方势力角逐，一场更大的阴谋正等待着他。他必须在这个权谋世界里找到自己的生存之道。",
      imageSeq: "cat-tv-05",
      imageQuery: "Chinese historical fantasy drama poster, ancient palace courtyard, warm golden sunlight, elegant costume design aesthetic, atmospheric mist, cinematic composition, 8K quality",
    },
    {
      id: "t6",
      title: "与凤行",
      category: "电视剧",
      rating: 8.4,
      views: "3210万",
      year: "2024",
      region: "中国大陆",
      description: "碧苍王沈璃为逃婚落下凡间，被凡人行止所救，两人共同经历重重考验。仙侠世界的爱恨纠葛，一段跨越天界的绝美爱恋。",
      imageSeq: "cat-tv-06",
      imageQuery: "Chinese xianxia romance drama poster, celestial realm with floating clouds and phoenix, warm golden and rose tones, ethereal atmosphere, elegant flowing fabric, 8K quality",
    },
  ],
  zongyi: [
    {
      id: "z1",
      title: "奔跑吧第八季",
      category: "综艺",
      rating: 8.2,
      views: "2340万",
      year: "2024",
      region: "中国大陆",
      description: "国民综艺再出发！跑男团携手新成员，在全新赛制和趣味挑战中，为观众带来持续不断的欢乐与感动。",
      imageSeq: "cat-variety-01",
      imageQuery: "Chinese variety show poster, outdoor sports theme, bright warm sunlight, energetic atmosphere, colorful and vibrant composition, 8K quality",
    },
    {
      id: "z2",
      title: "披荆斩棘第四季",
      category: "综艺",
      rating: 8.5,
      views: "1890万",
      year: "2024",
      region: "中国大陆",
      description: "多位实力派男艺人集结，通过舞台竞演突破自我。他们用汗水与才华，在这个舞台上重新定义'哥哥'的力量。",
      imageSeq: "cat-variety-02",
      imageQuery: "Chinese music competition show poster, stage with dramatic spotlight, warm golden stage lighting, passionate performance atmosphere, dynamic composition, 8K quality",
    },
    {
      id: "z3",
      title: "向往的生活第八季",
      category: "综艺",
      rating: 8.3,
      views: "1560万",
      year: "2024",
      region: "中国大陆",
      description: "回归田园，慢享生活。黄磊、何炅与嘉宾们在蘑菇屋中自给自足，用美食与真诚招待每一位到访的朋友。",
      imageSeq: "cat-variety-03",
      imageQuery: "Chinese slow-life variety show poster, countryside cottage with garden, warm golden afternoon light, peaceful rural atmosphere, cozy natural composition, 8K quality",
    },
    {
      id: "z4",
      title: "歌手2024",
      category: "综艺",
      rating: 8.7,
      views: "3210万",
      year: "2024",
      region: "中国大陆",
      description: "顶级歌手同台竞技，用声音征服舞台。国际实力唱将加盟，华语乐坛全明星阵容，每一场都是听觉盛宴。",
      imageSeq: "cat-variety-04",
      imageQuery: "Music competition TV show poster, grand stage with warm spotlights and smoke effects, dramatic concert atmosphere, golden and amber lighting, 8K quality",
    },
  ],
  dongman: [
    {
      id: "a1",
      title: "哪吒之魔童闹海",
      category: "动漫",
      rating: 9.6,
      views: "8920万",
      year: "2025",
      region: "中国大陆",
      description: "天劫之后，哪吒和敖丙的灵魂虽然保住，但肉身濒临消散。太乙真人用七色宝莲为他们重塑肉身，然而过程中的重重困难远超想象。",
      imageSeq: "cat-anime-01",
      imageQuery: "Chinese mythology animated film poster, fire and water elements intertwining, dramatic lighting, epic fantasy atmosphere, warm orange and gold colors, cinematic rendering, 8K quality",
    },
    {
      id: "a2",
      title: "长安三万里",
      category: "动漫",
      rating: 9.1,
      views: "4530万",
      year: "2023",
      region: "中国大陆",
      description: "安史之乱后数年，吐蕃大军入侵西南。困守孤城的高适向监军太监回忆起自己与李白的一生往事，两位诗人跌宕起伏的命运交织在大唐盛衰之中。",
      imageSeq: "cat-anime-02",
      imageQuery: "Tang Dynasty Chinese animated film poster, ancient Chang'an city skyline, golden sunset, ink wash painting style blending with 3D, poetic atmosphere, warm amber tones, 8K quality",
    },
    {
      id: "a3",
      title: "深海",
      category: "动漫",
      rating: 8.8,
      views: "2340万",
      year: "2023",
      region: "中国大陆",
      description: "一个沉浸在自己世界的少女参宿，误入梦幻深海世界。在寻找妈妈的旅途中，她遇到了神秘的深海大饭店老板南河，一段奇妙的冒险由此展开。",
      imageSeq: "cat-anime-03",
      imageQuery: "Chinese animated fantasy film poster, deep ocean with bioluminescent creatures, magical underwater world, warm amber and deep blue contrast, dreamlike atmosphere, 8K quality",
    },
    {
      id: "a4",
      title: "鬼灭之刃 柱训练篇",
      category: "动漫",
      rating: 9.0,
      views: "1870万",
      year: "2024",
      region: "日本",
      description: "为了迎接与鬼舞辻无惨的最终决战，炭治郎与伙伴们在九柱的指导下展开严苛训练。每个人的实力都在极限中突破，大战一触即发。",
      imageSeq: "cat-anime-04",
      imageQuery: "Japanese anime action series poster, samurai training in traditional dojo, warm sunset light through paper screens, dynamic sword action, atmospheric, 8K quality",
    },
    {
      id: "a5",
      title: "间谍过家家第二季",
      category: "动漫",
      rating: 9.2,
      views: "1560万",
      year: "2024",
      region: "日本",
      description: "间谍父亲、杀手母亲、读心术女儿，这个伪装家族的日常依然充满了惊险与温馨。福杰一家的新冒险，欢笑与感动继续。",
      imageSeq: "cat-anime-05",
      imageQuery: "Japanese anime comedy series poster, stylish spy family in retro European setting, warm afternoon light, elegant and playful atmosphere, 8K quality",
    },
  ],
  jilupian: [
    {
      id: "d1",
      title: "地球脉动第三季",
      category: "纪录片",
      rating: 9.7,
      views: "2340万",
      year: "2023",
      region: "英国",
      description: "BBC王牌纪录片系列回归。从深海到雪山，从丛林到沙漠，用最先进的摄影技术捕捉地球上最震撼的生命奇迹。",
      imageSeq: "cat-doc-01",
      imageQuery: "Nature documentary poster, breathtaking landscape with mountains and ocean, golden hour lighting, warm natural tones, aerial photography style, serene epic composition, 8K quality",
    },
    {
      id: "d2",
      title: "舌尖上的中国第四季",
      category: "纪录片",
      rating: 9.3,
      views: "3210万",
      year: "2024",
      region: "中国大陆",
      description: "深入中国各地，探寻食物背后的人情故事。从田间到餐桌，每一道美食都承载着一方水土的记忆与情感。",
      imageSeq: "cat-doc-02",
      imageQuery: "Chinese food documentary poster, traditional kitchen with steaming dishes, warm golden light, appetizing atmosphere, rustic wooden table setting, 8K quality",
    },
    {
      id: "d3",
      title: "我们的星球第二季",
      category: "纪录片",
      rating: 9.5,
      views: "1890万",
      year: "2024",
      region: "英国",
      description: "探索全球最独特的生态系统和野生动物栖息地，揭示自然界的奇妙关联与动物迁徙的壮丽景观。每一帧都是壁纸级画面。",
      imageSeq: "cat-doc-03",
      imageQuery: "Wildlife documentary poster, vast savanna with migrating animals at golden sunset, warm natural light, epic scale landscape, 8K quality",
    },
    {
      id: "d4",
      title: "河西走廊",
      category: "纪录片",
      rating: 9.6,
      views: "980万",
      year: "2015",
      region: "中国大陆",
      description: "从政治、军事、经济、文化、宗教等多角度呈现了河西走廊及其连接的中国西部的历史。一部波澜壮阔的中华文明史诗。",
      imageSeq: "cat-doc-04",
      imageQuery: "Chinese historical documentary poster, ancient Silk Road landscape with desert and mountains, warm golden sunset over ruins, majestic and timeless atmosphere, 8K quality",
    },
  ],
  zixun: [
    {
      id: "n1",
      title: "2025春节档电影票房预测：谁能成为最大赢家？",
      category: "资讯",
      rating: 0,
      views: "890万",
      year: "2025",
      region: "中国大陆",
      description: "春节档向来是电影市场的兵家必争之地。多部备受瞩目的大片定档2025春节，让我们来分析各片的市场前景。",
      imageSeq: "cat-news-01",
      imageQuery: "Chinese cinema box office news visual, modern movie theater entrance with warm red and gold festive decorations, bustling crowd, celebratory atmosphere, 8K quality",
    },
    {
      id: "n2",
      title: "国产科幻电影的技术突破与未来展望",
      category: "资讯",
      rating: 0,
      views: "670万",
      year: "2025",
      region: "中国大陆",
      description: "从《流浪地球》到《封神》系列，中国电影工业在视效技术上取得了长足进步。业内专家解读国产科幻的未来发展方向。",
      imageSeq: "cat-news-02",
      imageQuery: "Chinese sci-fi film industry visual, futuristic film studio with advanced technology equipment, warm ambient lighting, creative workspace atmosphere, 8K quality",
    },
  ],
};

export const categoryMeta: Record<string, { title: string; description: string }> = {
  dianying: {
    title: "电影 - 芒果视频高清在线观看",
    description: "芒果视频电影频道提供最新热门电影、经典大片1080P超清在线观看。动作片、喜剧片、科幻片、爱情片等海量电影资源，媲美香蕉视频、红桃视频，流畅不卡顿。",
  },
  dianshiju: {
    title: "电视剧 - 芒果视频高清在线观看",
    description: "芒果视频电视剧频道汇集国产剧、韩剧、美剧、日剧等热门电视剧全集，1080P超清画质在线播放。追剧就来芒果视频，流畅不缓冲。",
  },
  zongyi: {
    title: "综艺 - 芒果视频高清在线观看",
    description: "芒果视频综艺频道提供最新热门综艺节目在线观看，包括真人秀、音乐竞演、脱口秀等，1080P超清画质，笑点不断。",
  },
  dongman: {
    title: "动漫 - 芒果视频高清在线观看",
    description: "芒果视频动漫频道精选国漫、日漫等热门动漫作品，1080P超清画质在线观看。二次元爱好者的一站式动漫平台。",
  },
  jilupian: {
    title: "纪录片 - 芒果视频高清在线观看",
    description: "芒果视频纪录片频道提供自然探索、人文历史、科技揭秘等高质量纪录片，1080P超清画质，用镜头发现世界。",
  },
  zixun: {
    title: "影视资讯 - 芒果视频",
    description: "芒果视频资讯频道提供最新影视资讯、行业动态、影评剧评等内容，掌握娱乐风向标，尽在芒果视频。",
  },
};